export const DEBUGGER_MESSAGE_HISTORY_LENGTH = 100;

export const AVATAR_IMAGE_SIZE = 300;
export const PLAYER_SIZE = 220;
export const PLAYER_RADIUS = PLAYER_SIZE / 2;

export const PHOTO_BOOTH_FRAME_PADDING = 16;

export const COLOR_WHITE = 0xffffff;
export const COLOR_BLACK = 0x000000;
export const COLOR_WARNING = 0xb00020;
export const COLOR_GREY = 0x666666;
export const COLOR_NAVY = 0x091d50;
export const COLOR_BLACK_GREY = 0x333333;
export const COLOR_INACTIVE_GREY = 0x777777;

export const RING_ALPHA = 0.3;

export const INITIAL_MUSIC_VOLUME = 1;

// FIXME: these are static, and social is themed. This should probably be replaced with a dynamic theme
export const COLORS = {
  playerBorder: 0x7634dd,
  participantBorder: COLOR_WHITE,
  maskColor: COLOR_WHITE,
  boundaryFill: 0x7634dd,
  boundaryBorder: 0x7634dd,
};

export const FONT_FAMILY = 'Europa-Regular';
export const FONT_FAMILY_LIGHT = 'Europa-Light';
export const FONT_FAMILY_MEDIUM = 'Europa-Medium';
export const FONT_FAMILY_BOLD = 'Europa-Bold';

export const RTMP_PORT = 1935;

export const DEFAULT_REGION = 'us-east-2';

export const MAX_DISTANCE = 880;
export const MID_DISTANCE = 660;
export const MIN_DISTANCE = 440;

export const MAX_DISTANCE_V1 = 820;
export const MIN_DISTANCE_V1 = 420;

export const ALPHA_MASK = 0.001;
